import {Component, OnInit, signal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {CodaltComponent} from '../codalt.component';
import {BreadcrumbComponent} from '../services/breadcrumb/breadcrumb.component';
import {Routenames} from '../classes/route-name.enum';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {LeaveService} from '../services/leave.service';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {Leave, LeaveType} from '../classes/leave';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {DatePipe, SlicePipe} from '@angular/common';
import {DatetimeBeforePipe} from '../pipes/datetime-before.pipe';
import {IsOtherDatePipe} from '../pipes/other-date.pipe';
import {User} from '../classes/user.class';
import {CodaltDatePipe} from '../pipes/codalt-date.pipe';
import {UserService} from '../services/user/user.service';
import {HasRolePipe} from '../pipes/has-role.pipe';
import {Title} from '@angular/platform-browser';
import {ByIdPipe} from '../by-id.pipe';

@Component({
    selector: 'app-leave',
    templateUrl: './leave.component.html',
    styleUrls: ['./leave.component.scss'],
    imports: [
        BreadcrumbComponent,
        MatCheckbox,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
        DatePipe,
        RouterLink,
        DatetimeBeforePipe,
        IsOtherDatePipe,
        CodaltDatePipe,
        HasRolePipe,
        SlicePipe,
        ByIdPipe
    ]
})
export class LeaveComponent extends CodaltComponent implements OnInit {
    readonly leaves = signal<Leave[]>(null);
    readonly leaveTypes = signal<LeaveType[]>(null);
    readonly users = signal<User[]>(null);

    now = new Date();
    fcShowHistoric = new FormControl(false);

    public constructor(
        private confirmDialog: ConfirmDialogService,
        private leaveService: LeaveService,
        private titleService: Title,
        private userService: UserService,
    ) {
        super();
        this.crumbs = [
            {name: 'Verlof', route: Routenames.leave}
        ];
        this.titleService.setTitle(`Verlof ${this.environment.titleAppend}`);
    }

    ngOnInit() {
        this.subscriptions.add(
            this.userService.getList().subscribe(users => {
                this.users.set(users);
            })
        );
        this.subscriptions.add(
            this.leaveService.getLeaveTypes().subscribe(leaveTypes => {
                this.leaveTypes.set(leaveTypes);
            })
        );

        this.getLeaves();

        this.subscriptions.add(
            this.fcShowHistoric.valueChanges.subscribe(() => {
                this.getLeaves();
            })
        );

        this.subscriptions.add(
            this.leaveService.getLeaves().subscribe({
                next: (leaves) => this.leaves.set(leaves),
                error: err => console.error(err)
            })
        )
    }

    delete(event, leave?: Leave) {
        event.stopPropagation();

        this.confirmDialog.confirm(
            'Verlof verwijderen',
            `Weet u zeker dat u verlof ${leave.comment} wilt verwijderen?`,
            'Verwijderen',
            'Annuleren')
            .then(() => {
                this.leaveService.deleteLeave(leave.id).subscribe(() => {
                    this.leaves.update(leaves => leaves.filter(leaveFilter => leaveFilter.id !== leave.id));
                });
            });
    }

    approve(event, leave?: Leave) {
        event.stopPropagation();
        this.subscriptions.add(
            this.leaveService.approveLeave(leave.id).subscribe(response => {
                this.leaves.update(leaves => leaves.map(l => l.id === response.data.id ? response.data : l));
            })
        );
    }

    getLeaves() {
        this.subscriptions.add(
            this.leaveService.getLeaves(this.fcShowHistoric.value).subscribe(leaves => {
                this.leaves.set(leaves);
            })
        );
    }
}
